import { render, staticRenderFns } from "./ScoreDrawer.vue?vue&type=template&id=7f38ec42&"
import script from "./ScoreDrawer.vue?vue&type=script&lang=js&"
export * from "./ScoreDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports